import ButtonBase from '@mui/material/ButtonBase'
import List from '@mui/material/List'
import ListItemButton from '@mui/material/ListItemButton'
import ListItemIcon from '@mui/material/ListItemIcon'
import ListItemText from '@mui/material/ListItemText'
import Typography from '@mui/material/Typography'
import { Link, LinkProps, matchPath, useLocation } from 'react-router-dom'

import { useDrawer } from '../../hooks/useDrawer'
import { borderRadius } from '../../store/constant'
import { MenuGroup, MenuItem } from './MenuLinks'
import NavItem from './NavItem'
import { forwardRef } from 'react'

export default function NavGroup({ item }: { item: MenuGroup }) {
  const { drawerOpen, handlerDrawerOpen, isDrawerExpanded, isMiniDrawer } =
    useDrawer()

  const items = item.children?.map((menu: MenuItem) => {
    return <NavItem key={menu.id} item={menu} />
  })
  const { pathname } = useLocation()
  const isSelected = !!(
    item.url && matchPath({ path: item.url, end: true }, pathname)
  )

  const SmallScreenAwareLink = forwardRef<HTMLAnchorElement, LinkProps>(
    (props, ref) => {
      const { onClick: originalOnClick, ...rest } = props

      function handleClick(e: React.MouseEvent<HTMLAnchorElement>) {
        if (isMiniDrawer) handlerDrawerOpen()
        originalOnClick?.(e)
      }

      return <Link ref={ref} {...rest} onClick={handleClick} />
    },
  )

  SmallScreenAwareLink.displayName = 'SmallScreenAwareLink'

  const Icon = item?.icon
  const itemIcon = Icon ? (
    <Icon stroke={1.5} sx={{ fontSize: 24, stroke: '1.5' }} />
  ) : null
  return (
    <List
      subheader={
        <ListItemButton
          disableRipple={true}
          selected={isSelected}
          component={SmallScreenAwareLink}
          to={item.url || ''}
          onClick={item.onClick}
          sx={{
            padding: drawerOpen ? '8px 16px' : '0',
            color: 'grey.700',
            zIndex: 1201,
            borderRadius: `${borderRadius}px`,
            mb: 0.5,
            '&:hover': {
              backgroundColor: 'secondary.main',
            },
            '&.Mui-selected': {
              backgroundColor: 'secondary.dark',
            },
            '&.Mui-selected:hover': {
              backgroundColor: 'secondary.dark',
            },
          }}
        >
          <ButtonBase aria-label='theme-icon' disableRipple={true}>
            <ListItemIcon
              sx={{
                color: isSelected ? 'white' : 'inherit',
                ...(!drawerOpen && {
                  borderRadius: `${borderRadius}px`,
                  width: 46,
                  height: 46,
                  alignItems: 'center',
                  justifyContent: 'center',
                }),
              }}
            >
              {itemIcon}
            </ListItemIcon>
          </ButtonBase>
          {isDrawerExpanded && (
            <ListItemText>
              <Typography
                noWrap
                variant='h5'
                sx={{
                  ml: 1.5,
                  color: 'inherit',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                }}
              >
                {item.title}
              </Typography>
            </ListItemText>
          )}
        </ListItemButton>
      }
    >
      {items}
    </List>
  )
}
